/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Overview_DesktopInputs */

const he_dashboard_overview_desktop = /** @type {(inputs: Dashboard_Overview_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחשב`)
};

const en_dashboard_overview_desktop = /** @type {(inputs: Dashboard_Overview_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop`)
};

/**
* | output |
* | --- |
* | "Desktop" |
*
* @param {Dashboard_Overview_DesktopInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_overview_desktop = /** @type {((inputs?: Dashboard_Overview_DesktopInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Overview_DesktopInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_overview_desktop(inputs)
	return en_dashboard_overview_desktop(inputs)
});